import type { SettingsTemplateModel } from '@/shared/generated'

import React from 'react'

import { ErrorBoundary } from '@/shared/components/ErrorBoundary'
import { Modal, ModalContent } from '@/shared/components/ui/modal'
import { ApplyAction } from '@/shared/generated'

import { ApplyToOptimizationGroups } from './ApplyToOptimizationGroups'
import { ApplyToPricingCampaigns } from './ApplyToPricingCampaigns'
import { ApplyToScenarios } from './ApplyToScenarios'

export function ApplySettingsTemplateModal({
	isOpen,
	close,
	template,
	action,
}: {
	isOpen: boolean
	close: () => void
	template: SettingsTemplateModel
	action: ApplyAction
}) {
	return (
		<Modal
			open={isOpen}
			onOpenChange={(open) => {
				if (!open) {
					close()
				}
			}}
		>
			<ModalContent className='max-w-5xl' data-testid='apply-template-modal'>
				<ErrorBoundary>
					{[
						ApplyAction.UpdatePricingCampaignSettings,
						ApplyAction.ReplacePricingCampaignSettings,
					].includes(action) && (
						<ApplyToPricingCampaigns
							action={action}
							template={template}
							close={close}
						/>
					)}
					{[
						ApplyAction.AddWhatIfScenario,
						ApplyAction.ReplaceMainScenario,
					].includes(action) && (
						<ApplyToOptimizationGroups
							action={action}
							template={template}
							close={close}
						/>
					)}
					{[ApplyAction.UpdateScenarioSettings].includes(action) && (
						<ApplyToScenarios
							action={action}
							template={template}
							close={close}
						/>
					)}
				</ErrorBoundary>
			</ModalContent>
		</Modal>
	)
}
